export default __webpack_public_path__ + "9c557658cacba4b90372d9cfdb33e0fc.svg";